import { render, staticRenderFns } from "./TaxType.vue?vue&type=template&id=f3a3b64a"
import script from "./TaxType.vue?vue&type=script&lang=js"
export * from "./TaxType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports